import { DEFAULT_COUNTRY } from "@constants/store";

export const isDefaultCountry = (country) => {
  return country.iso === DEFAULT_COUNTRY.iso;
};

export const defaultCountryObject = (countries) =>
  countries?.find(({ iso }) => iso === DEFAULT_COUNTRY.iso) || DEFAULT_COUNTRY;

export const getCountryDataFromName = (countries, userBaseCountry) =>
  countries?.find((country) => country?.name?.toLowerCase() == userBaseCountry?.toLowerCase()) ||
  defaultCountryObject(countries);
